export default __webpack_public_path__ + "static/media/bitcoin-icon.cc34c8dd.svg";